import Icons from "@/src/components/Icons";
import { Link, useNavigate } from "react-router-dom";

function Report() {
  let history = useNavigate();
  return (
    <div>
      <h4
        className="title text-xl font-extrabold flex items-center cursor-pointer justify-center"
        onClick={() => history("/")}
      >
        گزارش
      </h4>
      <div className="items flex flex-col gap-4 mt-6">
        <Link to={"/report/order"}>
          <div className="item-goftino min-h-[70px] flex justify-between bg-white items-center p-2 rounded-xl shadow-mmpz cursor-pointer">
            <h4 className="text-xl">فروش</h4>
            <Icons name="arrowLeft" fill="none" stroke="#1E1E1E" size={40} />
          </div>
        </Link>
        <Link to={'/report/penalty'} className="item-goftino min-h-[70px] flex justify-between bg-white items-center p-2 rounded-xl shadow-mmpz cursor-pointer">
          <h4 className="text-xl">خطا و جریمه</h4>
          <Icons name="arrowLeft" fill="none" stroke="#1E1E1E" size={40} />
        </Link>
        <Link to={'/report/archive'} className="item-goftino min-h-[70px] flex justify-between bg-white items-center p-2 rounded-xl shadow-mmpz cursor-pointer">
          <h4 className="text-xl">آرشیو سفارش‌ها</h4>
          <Icons name="arrowLeft" fill="none" stroke="#1E1E1E" size={40} />
        </Link>
        <Link to={'/report/score'} className="item-goftino min-h-[70px] flex justify-between bg-white items-center p-2 rounded-xl shadow-mmpz cursor-pointer">
          <h4 className="text-xl">امتیاز</h4>
          <Icons name="arrowLeft" fill="none" stroke="#1E1E1E" size={40} />
        </Link>
      </div>
    </div>
  );
}

export default Report;
